import * as React from "react";
import PropTypes from "prop-types";
import { log } from "@lululemon/mwa-utils";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
    this.reportToSentry = this.reportToSentry.bind(this);
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  async componentDidCatch(error, errorInfo) {
    var _this$props, _this$props2;
    if ((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.onError && typeof ((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.onError) === "function") {
      this.props.onError(error, errorInfo);
    }
    await this.reportToSentry(error, errorInfo);
  }
  async reportToSentry(error) {
    const {
      remote,
      componentName,
      children
    } = this.props;
    const libVersions = {};
    const checkIfExists = async function checkIfExists(moduleName) {
      try {
        return await import(`${moduleName}/package.json`);
      } catch (_unused) {
        return {
          version: "Module not used"
        };
      }
    };
    const [mwaUtils, mwaWebpack, mwaCommon, webpack, next] = await Promise.all([checkIfExists("@lululemon/mwa-utils"), checkIfExists("@lululemon/mwa-webpack"), checkIfExists("@lululemon/mwa-common"), checkIfExists("webpack"), checkIfExists("next")]);
    libVersions["@lululemon/mwa-utils"] = mwaUtils.version;
    libVersions["@lululemon/mwa-webpack"] = mwaWebpack.version;
    libVersions["@lululemon/mwa-common"] = mwaCommon.version;
    libVersions["webpack"] = webpack.version;
    libVersions["next"] = next.version;
    log.error(`Error rendering ${componentName}: ${(error === null || error === void 0 ? void 0 : error.message) || error}`, {
      error,
      props: children === null || children === void 0 ? void 0 : children.props,
      libVersions
    }, {
      tags: {
        isRenderError: true,
        componentName
      }
    }, null, remote);
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }
    if (!process.browser) {
      try {
        return this.props.children;
      } catch (error) {
        // if the render crashes server-side
        this.reportToSentry(error);
        return null;
      }
    }
    return this.props.children;
  }
}
ErrorBoundary.defaultProps = {
  componentName: "",
  remote: null,
  fallback: null
};
ErrorBoundary.propTypes = {
  componentName: PropTypes.string,
  fallback: PropTypes.node,
  remote: PropTypes.string
};
export default ErrorBoundary;